import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import store from './redux/Store';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <GoogleOAuthProvider clientId="418169775508-ginklikkeb729ilaeh08fsu5qtm6421s.apps.googleusercontent.com">
    <Provider store={store}> {/* Wrap the App with Redux Provider */}
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
 // </GoogleOAuthProvider>
);
